var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "flickity",
    {
      ref: "flickity",
      staticClass: "collection-slider-main",
      attrs: {
        options: _vm.flickityOptions,
        "aria-label": "Product Collection Slider",
        role: "group"
      }
    },
    [
      _vm._l(_vm.products, function(product) {
        return [
          _c(
            "div",
            { key: product.id, staticClass: "carousel-cell" },
            [
              _c("ProductCard", {
                key: _vm.productKey,
                attrs: {
                  inSlider: true,
                  data: JSON.stringify(product.productData),
                  quickviewData: JSON.stringify(product.quickview)
                },
                on: {
                  "refresh-product": _vm.refreshProductCard,
                  sliderQuickview: _vm.sendDataToSliderModal
                }
              })
            ],
            1
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }